<template>
  <div>
    <div class="pa-5 pt-0 pb-0" >
      <v-row style="justify-content:between">
        <v-col cols="12" sm="12" md="6" lg="6" class="sub-title">Upcoming Activation</v-col>
        <v-col class="pt-2" cols="12" sm="12" md="2" lg="2">
          <v-text-field
          class="mt-0"
          style="max-width:300px"
          v-model="selectedFilter.search"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isAM">
          <v-autocomplete
            :items="AM"
            item-value="id"
            item-text="name"
            label="AM"
            v-model="selectedFilter.AM"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isCC">
          <v-autocomplete
            :items="CC"
            item-value="id"
            item-text="name"
            label="CC"
            v-model="selectedFilter.CC"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <div class="pa-5 pt-2">
      <v-data-table
        class="dashboard-activation-data-table elevation-1"
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        :items-per-page="5"
        :search="selectedFilter.search"
      >
        <template v-slot:[`item.name`]="{ item }">
          <td class="text-left">
            {{item.name || ''}}
          </td>
        </template>
        <template v-slot:[`item.IONumber`]="{ item }">
          <td class="text-center">
            {{item.IONumber || ''}}
          </td>
        </template>
        <template v-slot:[`item.budget`]="{ item }">
          <td class="text-center">
            <span>${{item.budget | thousandSeprator}}</span>
          </td>
        </template>
        <template v-slot:[`item.quoteAcceptanceDate`]="{ item }">
          <td class="text-center">
            <span>{{item.quoteAcceptanceDate ? formatDate(item.quoteAcceptanceDate) : ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.activationDate`]="{ item }">
          <td class="text-center pt-2 pb-2">
            <div class="d-flex flex-row" style="justify-content:center">
              <v-text-field
                class="edit-date-box"
                placeholder="Activation Date"
                v-model="item.activationDate"
                outlined
                dense
                hide-details
                @input="checkDate(item, 'activationDate', 'validActivationDate', null)"
                @keyup.enter="checkDate(item, 'activationDate', 'validActivationDate', true)"
              >
              </v-text-field>
              <div class="date-picker-inner">
                <date-picker
                  className="input-field"
                  :options="{theme: 'icon', confirm: true}"
                  :status="item.actDateCal"
                  @changeDate="setDateFromPicker(item, 'activationDate', ...arguments)"
                />
              </div>
            </div>
            <div v-if="item.validActivationDate === false">
              <span class="text-danger ma-0 pt-1">Invalid Start Date</span>
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import { mapState } from 'vuex'
import moment from 'moment'
import DatePicker from '@/components/scoped/custom/DatePicker'
import utils from '@/utils'
// import userAPIs from '@/components/views/User/userAPIs';
export default {
  name: 'DashboardActivationDataTable',
  components: {
    DatePicker
  },
  data() {
    return {
      headers: [
        {
          text: 'Deal Name',
          value: 'name',
          align: 'center'
        },
        {
          text: 'IO Number',
          value: 'IONumber',
          align: 'center'
        },
        {
          text: 'IO amount',
          value: 'budget',
          align: 'center'
        },
        {
          text: 'Quote Acceptance Date',
          value: 'quoteAcceptanceDate',
          align: 'center'
        },
        {
          text: 'Activation Date',
          value: 'activationDate',
          align: 'center'
        }
      ],
      items: [],
      filteredItems: [],
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false
    }
  },
  props: ['AM', 'CC'],
  computed: {
    ...mapState({
      dashboardCampaigns: state => state.campaign.dashboardActivations,
      savedDashboardStatus: state => state.campaign.savedDashboardStatus
    }),
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    },
    isAM: function() {
      return Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    },
    isCC: function() {
      return Number(this.$store.state.user.role) === config.userRoles.AD_STRATEGIST
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    currentUserID: function () {
      return this.$store.state.user.id
    }
  },
  async mounted() {
    this.init()
    setTimeout(() => {
      this.setAMCC()
    }, 2000)
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch('campaign/getDashboardActivation', {})
      this.items = this.dashboardCampaigns.map(d => d)
      this.filteredItems = this.items.map(item => item)
      this.loading = false
    },
    async updateData(item) {
      await this.$store.dispatch('campaign/saveDashboardStatus', {
        id: item.id,
        type: config.dashboardTypes.activation,
        activationDate: item.activationDate
      })
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    checkDate(item, fieldName, validFieldName, isUpdate) {
      // check date format if entered only
      item[validFieldName] = false
      const itemIdx = this.filteredItems.indexOf(item)
      if (utils.func.isDateFormatValid(item[fieldName]) || !item[fieldName]) {
        item[validFieldName] = true
        if (isUpdate) {
          this.updateData(item)
        }
      }
      this.filteredItems[itemIdx] = item
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
    },
    setDateFromPicker(item, fieldName, value) {
      const itemIdx = this.filteredItems.indexOf(item)
      this.filteredItems[itemIdx][fieldName] = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
      this.updateData(item)
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.CC)))
      }
    },
    setAMCC() {
      if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        let matchAM = this.AM.find(a => a.id === this.currentUserID)
        this.selectedFilter.AM = matchAM
      }
      if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID
      }
    }
  }
}
</script>
<style scoped>
  .edit-date-box {
    max-width: 200px;
  }
  .dashboard-activation-data-table .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
  .filter-area {
    justify-content: right;
  }
</style>



// WEBPACK FOOTER //
// DashboardActivationDataTable.vue?383a73e3